import BaseAPI from './base'
/**
 * API xử lý lớp học
 */
class SelfLearningDetailAPI extends BaseAPI {}

export default new SelfLearningDetailAPI('v1/self-learning-detail', 'CourseDetail')
